import styled from 'styled-components';

export const LifeTitle = styled.div`
    font-size: 25px;
    font-weight: 600;
`;

export const LifeTitleH1 = styled.h1`
    margin: 0;
    font-size: 25px;
    font-weight: 600;
`;
